import { put, takeEvery, select } from 'redux-saga/effects';
import { getWithToken } from '../../../api/network';
import {
  appNotify,
  deleteShape,
  setSelectedGroupIsLoading,
  setSelectedGroupId,
  setSelectedModule
} from '../../../store/actions';
import { deleteWithToken } from '../../../api/network';
import { selectedModuleSelector } from 'store/selectors'; 

export function* deleteShapeSaga() {
  yield takeEvery(deleteShape, function* ({ payload }) {
    try {
      yield put(setSelectedGroupIsLoading(true));

      const { shapeId, selectedGroupId } = payload;
      const url = `/api/assumptions/shapes/${shapeId}`;
      yield deleteWithToken(url);

      yield put(setSelectedGroupIsLoading(false));
      // reloads the group
      yield put(setSelectedGroupId(selectedGroupId));
      yield put(appNotify('Shape deleted', 'success'));

      const selectedModule = yield select(selectedModuleSelector); 
      const moduleUrl = `/api/assumptions/modules/${selectedModule.moduleId}`; 
      const res = yield getWithToken(moduleUrl); 
      const data = yield res.json(); 
  
      yield put(setSelectedModule(data)); 
    } catch (error) {
      yield put(appNotify(`Failed to delete shape: ${error.message}`, 'error'));
      yield put(setSelectedGroupIsLoading(false));
    }
  });
}
